module.exports = __webpack_public_path__ + "img/java.ad5afceb.png";